import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

const getListingDetails = async (listingId: string) => {
  try {
    return await client.get(`/listings/${listingId}`, { noLoading: true })
  } catch (error) {
    throw error
  }
}

const useGetListingDetails = (listingId: string) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [`listing-${listingId}`],
    queryFn: () => getListingDetails(listingId),
    refetchOnWindowFocus: false
  })
  return { data, isLoading, refetch }
}

export default useGetListingDetails
